'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineServices = defineServices;

var _reportServiceFactory = require('./services/reportServiceFactory');

var _reportServiceFactory2 = _interopRequireDefault(_reportServiceFactory);

var _tradingAccountService = require('./services/tradingAccountService.js');

var _tradingAccountService2 = _interopRequireDefault(_tradingAccountService);

var _tariffChangesServiceFactory = require('./services/tariffChangesServiceFactory.js');

var _tariffChangesServiceFactory2 = _interopRequireDefault(_tariffChangesServiceFactory);

var _tariffServiceFactory = require('./services/tariffServiceFactory.js');

var _tariffServiceFactory2 = _interopRequireDefault(_tariffServiceFactory);

var _tradingParametersServiceFactory = require('./services/tradingParametersServiceFactory');

var _tradingParametersServiceFactory2 = _interopRequireDefault(_tradingParametersServiceFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineServices(rpcSystem) {
  rpcSystem.registerService('reportService', _reportServiceFactory2.default);
  rpcSystem.registerService('tradingAccountService', _tradingAccountService2.default);
  rpcSystem.registerService('tradingParametersService', _tradingParametersServiceFactory2.default);
  rpcSystem.registerService('tariffChangesService', _tariffChangesServiceFactory2.default);
  rpcSystem.registerService('tariffService', _tariffServiceFactory2.default);
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/services.js
// module id = 1462
// module chunks = 118